import { Component, OnInit } from '@angular/core';
import { HttpService } from '../service/http.service';
import { PdfDocumentHeaderFooter } from '../pdf-document-header-footer';
import { PdfDocumentTemplateService } from '../pdf-document-template.service';
import { PdfTemplateViewOption } from '../pdf-template-view-option.enum';

@Component({
  selector: 'app-pdf-templates-header-footer',
  templateUrl: './pdf-templates-header-footer.component.html',
  styleUrls: ['./pdf-templates-header-footer.component.css']
})
export class PdfTemplatesHeaderFooterComponent implements OnInit {

  headerFooters: PdfDocumentHeaderFooter[] = [];

  constructor(
    private httpService: HttpService,
    public pdfTemplateService: PdfDocumentTemplateService
  ) { }

  ngOnInit(): void {

    this.httpService.getAllPdfDocumentHeaderFooters().subscribe(res => {
      this.headerFooters = res;
    });
  }

  editSelectedPdfDocumentHeaderFooter(template: PdfDocumentHeaderFooter){
    this.pdfTemplateService.activeItemId = PdfTemplateViewOption.EDIT_HEADER_FOOTER;
    this.pdfTemplateService.selectedHeaderFooter = template;
  }

}
